export const DEFAULT_ACCENT = { modern: "#D94E28", bold: "#1E40AF" };

export const ACCENTS = [
  { hex: "#D94E28", name: "Thread orange" },
  { hex: "#1E40AF", name: "Cobalt" },
  { hex: "#0F766E", name: "Teal" },
  { hex: "#047857", name: "Emerald" },
  { hex: "#B91C1C", name: "Crimson" },
  { hex: "#BE185D", name: "Berry" },
  { hex: "#6D28D9", name: "Violet" },
  { hex: "#0F172A", name: "Ink" },
];

export const accentFor = (template, accent) => accent || DEFAULT_ACCENT[template] || DEFAULT_ACCENT.modern;

const lum = (hex) => {
  const c = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255).map((v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4));
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
};

// Text colour that stays readable on top of the accent.
export const onAccent = (hex) => (lum(hex) > 0.35 ? "#0F172A" : "#FFFFFF");

// Accent darkened enough to read as text on white.
export const accentText = (hex) => {
  if (lum(hex) <= 0.2) return hex;
  const mix = (i) => Math.round(parseInt(hex.slice(i, i + 2), 16) * 0.55).toString(16).padStart(2, "0");
  return `#${mix(1)}${mix(3)}${mix(5)}`;
};

export const isLight = (hex) => lum(hex) > 0.35;
